module.exports = __webpack_public_path__ + "2490aa08f40830bae35da50d6e38dbd5.svg";